import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { encodeTracks }   from "../components/Share";
import playlistCache       from "../components/playlistCache";
import "../styles/RiffAiLoading.css";

export function RiffAiLoading() {
  const { state } = useLocation();
  const navigate  = useNavigate();

  useEffect(() => {
    if (!state?.answers) {
      navigate("/riffai", { replace: true });
      return;
    }

    const key = JSON.stringify(state.answers);

    /* ───── StrictMode: ответ уже в кеше ───── */
    if (playlistCache.has(key)) {
      const tracks = playlistCache.get(key);
      const slug   = encodeTracks(tracks);

      navigate(`/riffai/result/${slug}`, {
        state  : { playlist: tracks },
        replace: true,
      });
      return;
    }

    /* ───── первый реальный вызов бэкенда ───── */
    let cancelled = false;

    (async () => {
      try {
        const API = process.env.REACT_APP_API_BASE || "";
        const res = await fetch(`${API}/api/riffai/`, {
          method : "POST",
          headers: { "Content-Type": "application/json" },
          body   : JSON.stringify({ answers: state.answers }),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const json = await res.json();
        if (cancelled) return;

        playlistCache.set(key, json.tracks);

        const slug = encodeTracks(json.tracks);
        navigate(`/riffai/result/${slug}`, {
          state  : { playlist: json.tracks },
          replace: true,
        });
      } catch (err) {
        console.error(err);
        if (!cancelled) {
          navigate("/riffai/result/err", { state: { error: true }, replace: true });
        }
      }
    })();

    return () => { cancelled = true; };
  }, [state, navigate]);

  /* ----------- лоадер ----------- */
  return (
    <section className="riff-loading-screen">
      <video
        className="riff-loading-video"
        src="/assets/Animation - 1744117405234 (2).webm"
        autoPlay
        muted
        loop
        playsInline
      />
    </section>
  );
}
